export const sortItemsByPosition = (itemsArray: any[]) => {
  return itemsArray.sort((a, b) => {
    return a.POSITION_IN_ARRAY - b.POSITION_IN_ARRAY;
  });
};
